<h3 mat-dialog-title>{{Title}}</h3>

<mat-dialog-content class="edit-dialog">
  <div fxLayout="row" fxLayoutAlign="center center">
    @if (loading) {
      <busy-indicator></busy-indicator>
    }
  </div>

  @if (!loading) {
    <div fxFlexFill fxLayoutAlign="space-around center">
      <fieldset class="fsNoFormat">
        <form #form="ngForm">
          @if (!CustomEdit) {
            <metadata-panel ngModelGroup="pnl_editDialog" [metadata]="item.Metadata" [model]="item.Entity">
          </metadata-panel>
        }
        @if (CustomEdit) {
          <div>
            @if (!hasCustomView) {
              <div>
                <!-- ! TODO - remove after conversion -->
                NO CUSTOM VIEW DEFINED FOR '{{editComponent}}'
              </div>
            }
            @if (hasCustomView) {
              <custom-view-downgrade [component]="editComponent" [custom-data-binding]="customDataBinding">
              </custom-view-downgrade>
            }
          </div>
        }
      </form>
    </fieldset>
  </div>
}
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close telemetry="Submission-EditCancel">
    Cancel
  </button>

  <button mat-raised-button color="primary" [disabled]="!CanSave" (click)="save()" telemetry="Submission-EditSave">
    Save
  </button>
</mat-dialog-actions>
